export default {
  init() {
    //
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-career.js